<script lang="ts">
  import { srcAt } from "../../support/graphics";

  export let width = 1000;
  export let height = 1000;
  export let layers: string[] = [];

  $: background = layers
    .filter(Boolean)
    .map((layer) => `url(${srcAt(layer, width)}) 0 0 no-repeat`)
    .reverse()
    .join(",");

  let tileOverlap = 2;
  let tileSize = 512;
  // Tiling is presently disabled. It seems fast enough, but let's
  // revisit with more demanding maps.
  let tilesX = Math.ceil(width / tileSize);
  let tilesY = Math.ceil(height / tileSize);

  let tiles = [];

  for (let tileX = 0; tileX < tilesX; tileX++) {
    let x = tileX * tileSize - tileX * tileOverlap;
    let tileWidth = Math.min(tileSize, width - x);

    for (let tileY = 0; tileY < tilesY; tileY++) {
      let y = tileY * tileSize - tileY * tileOverlap;
      let tileHeight = Math.min(tileSize, height - y);

      tiles.push({ x, y, width: tileWidth, height: tileHeight });
    }
  }
</script>

<svelte:head>
  {#each layers as layer}
    <link rel="preload" href={layer} as="image" />
  {/each}
</svelte:head>

{#each tiles as tile}
  <div
    class="Tile"
    style="background: {background};
           background-position: {-tile.x}px {-tile.y}px;
           background-size: {width}px {height}px;
           left: {tile.x}px;
           top: {tile.y}px;
           width: {tile.width}px;
           height: {tile.height}px;"
  ></div>
{/each}

<style>
  .Tile {
    position: absolute;
    overflow: hidden;
  }
</style>
